import i18n from '@/lang';
import { saveAs } from 'file-saver';
const ExcelJs = require('exceljs');
import { CARGO_TYPE, COLLECT_TYPE, ISMIX_START } from '@/views/finance/enums';
import { QUOTATION_MODEL } from '@/views/finance/utils';

// 通用表头
const headerObj = [
  {
    header: i18n.t('basicData.TheNameOfTheQuoteProposal'), // 报价方案名称
    key: 'name',
    width: 30
  },
  {
    header: i18n.t('basicData.BusinessPrincipal'), // 业务主体
    key: 'payableEntityName',
    width: 30
  },
  {
    header: i18n.t('basicData.Outlets'), // 网点
    key: 'siteName',
    width: 20
  },
  {
    header: i18n.t('basicData.PartitionSchemeName'), // 分区方案
    key: 'partitionName',
    width: 30
  },
  {
    header: i18n.t('basicData.PartitionName'), // 分区
    key: 'partitionIdentifier',
    width: 20
  },
  {
    header: i18n.t('basicData.zipCode'), // 分区邮编
    key: 'postCode',
    width: 20
  },
  {
    header: i18n.t('basicData.routeName'), // 车线
    key: 'partitionAffiliateId',
    width: 30
  },
  {
    header: i18n.t('vehicle.modelLabel'), // 车型
    key: 'vehicleType',
    width: 30
  }
];

// 安骏小屋
const hutColumns = [
  {
    header: i18n.t('basicData.ExpenseType'), // 费用类型
    key: 'feeTypeCode',
    width: 30
  },
  {
    header: i18n.t('basicData.QuantityStartTicketNotIncluded'), // 货量开始（票）(不包含)
    key: 'startOfGoodsQuantity',
    width: 30
  },
  {
    header: i18n.t('basicData.EndOfVolumeTicketIncluded'), // 货量结束（票）(包含)
    key: 'endOfGoodsQuantity',
    width: 30
  },
  {
    header: i18n.t('basicData.PickUpPrice'), // 揽收价格
    key: 'price',
    width: 30
  },
  {
    header: i18n.t('basicData.logisticsSubsidy'), // 揽收补贴
    key: 'subsidy',
    width: 30
  },
  {
    header: 'ID', // id 下载报价的时候存在
    key: 'id',
    width: 20
  }
];

// 上门交件
const deliveryColumns = [
  {
    header: i18n.t('basicData.KilometersStartKM'), // 距离开始(KM) 不包含
    key: 'startWeight',
    width: 30
  },
  {
    header: i18n.t('basicData.MileageEndKM'), // 距离结束(KM) 包含
    key: 'endWeight',
    width: 30
  },
  {
    header: i18n.t('collectionCenter.hut') + i18n.t('collectionCenter.turnTransport') + i18n.t('basicData.BasePrice') + '(PT014)*', // 安俊小屋基础价格PT014
    key: 'price',
    width: 30
  },
  {
    header: i18n.t('collectionCenter.hut') + i18n.t('collectionCenter.turnTransport') + i18n.t('basicData.商家提成') + '(PT0015)*', // 安俊小屋转运商家提成PT015
    key: 'overshipmentPrice',
    width: 30
  },
  {
    header: i18n.t('collectionCenter.hut') + i18n.t('collectionCenter.turnTransport') + i18n.t('basicData.包裹价格') + '(PT016)*', // 安俊小屋转运包裹价格PT016
    key: 'standardPrice',
    width: 30
  },
  {
    header: i18n.t('basicData.最低货量'), // 最低货量
    key: 'overWeightExtraPrice',
    width: 30
  },
  {
    header: 'ID', // id 下载报价的时候存在
    key: 'id',
    width: 20
  }
];

// 上门揽收
const collectionColumns = [
  {
    header: i18n.t('collectionCenter.distance'), // 距离
    key: 'distanceModel',
    width: 30
  },
  {
    header: i18n.t('basicData.BasePrice') + '(PT003)*', // 基础价PT003
    key: 'standardPrice',
    width: 30
  },
  {
    header: i18n.t('basicData.揽收商家提成') + '(PT004)*', // 揽收商家提成PT004
    key: 'overshipmentPrice',
    width: 30
  },
  {
    header: i18n.t('basicData.揽收包裹价格') + '(PT013)*', // 揽收包裹价格PT013
    key: 'price',
    width: 30
  },
  {
    header: i18n.t('basicData.最低货量'), // 最低存货
    key: 'standardCargo',
    width: 30
  },
  {
    header: 'ID', // id 下载报价的时候存在
    key: 'id',
    width: 20
  }
];

// AJD【正常】
const normalColumns = [
  {
    header: i18n.t('basicData.KilometersStartKM'), // 公里数开始KM(不包含)
    key: 'startDistance',
    width: 30
  },
  {
    header: i18n.t('basicData.MileageEndKM'), // 公里数结束KM(包含)
    key: 'endDistance',
    width: 30
  },
  {
    header: i18n.t('basicData.DriverType'), // 司机类型
    key: 'vehicleType',
    width: 30
  },
  {
    header: i18n.t('basicData.DailyTaskCapacityFromBase'), // 起底日任务量
    key: 'standardCargo',
    width: 30
  },
  {
    header: i18n.t('basicData.BasicDeliveryFee') + '(PT005)', // 基础派送费
    key: 'standardPrice',
    width: 20
  },
  {
    header: i18n.t('basicData.ExceedingTargetIncentiveBonus') + '(PT012)', // 超目标激励奖金
    key: 'overshipmentPrice',
    width: 20
  },
  {
    header: i18n.t('basicData.AttendanceIncentiveBonus') + '(PT006)', // 出勤激励奖金
    key: 'incentiveBonus',
    width: 20
  },
  {
    header: i18n.t('basicData.FuelSubsidy') + '(PT009)', // 燃油补贴
    key: 'subsidy',
    width: 20
  },
  {
    header: i18n.t('basicData.inssExemption11'), // 减免INSS
    key: 'inssSelected',
    width: 20
  },
  {
    header: i18n.t('basicData.sestSenatExemption25'), // 减免Sest Senat
    key: 'sestSenatSelected',
    width: 20
  },
  {
    header: i18n.t('basicData.incomeTaxIRRF10'), // 个税IRRF
    key: 'irrfSelected',
    width: 20
  }
];

// AJD【大件】/DSP
const dspColumns = [
  {
    header: i18n.t('basicData.ExpenseType'), // 费用类型
    key: 'feeTypeCode',
    width: 30
  },
  {
    header: i18n.t('basicData.WeightStartKG'), // 重量开始KG(不包含)
    key: 'startWeight',
    width: 30
  },
  {
    header: i18n.t('basicData.WeightEndKG'), // 重量结束KG(包含)
    key: 'endWeight',
    width: 30
  },
  {
    header: '0-31KM' + i18n.t('basicData.Price'), // 0-31KM价格
    key: 'innerDistancePrice',
    width: 30
  },
  {
    header: '31-101KM' + i18n.t('basicData.Price'), // 31-101KM价格
    key: 'outerDistancePrice',
    width: 30
  },
  {
    header: '>=101KM' + i18n.t('basicData.Price'), // >=101KM价格
    key: 'greaterThanDistancePrice',
    width: 30
  },
  {
    header: '0-31KM' + i18n.t('basicData.ExcessWeightFareIncrease'), // 0-31KM超出重量加价(每KG)
    key: 'overWeightExtraPrice',
    width: 30
  },
  {
    header: '31-101KM' + i18n.t('basicData.ExcessWeightFareIncrease'), // 31-101KM超出重量加价（每KG）
    key: 'overKilometerExtraPrice',
    width: 30
  },
  {
    header: '>=101KM' + i18n.t('basicData.ExcessWeightFareIncrease'), // >=101KM超出重量加价（每KG）
    key: 'greaterThanKilometerExtraPrice',
    width: 30
  },
  {
    header: 'ID', // id 下载报价的时候存在
    key: 'id',
    width: 20
  }
];

// 运输报价
const distanceColumns = [
  // {
  //   header: i18n.t('basicData.WhetherToMixQuotes'), // 混合报价
  //   key: 'isMix',
  //   width: 30
  // },
  {
    header: i18n.t('basicData.报价模式'), // 报价模式
    key: 'quotationMode',
    width: 40
  },
  {
    header: i18n.t('basicData.KilometersStartKM'), // 公里开始(KM) 不包含
    key: 'startDistance',
    width: 30
  },
  {
    header: i18n.t('basicData.MileageEndKM'), // 公里结束(KM) 包含
    key: 'endDistance',
    width: 30
  },
  {
    header: i18n.t('basicData.ExpenseType'), // 费用类型
    key: 'feeTypeCode',
    width: 30
  },
  {
    header: i18n.t('basicData.Price'), // 价格
    key: 'price',
    width: 30
  },
  {
    header: 'ID', // id 下载报价的时候存在
    key: 'id',
    width: 20
  }
];

// 邮局
const postalColumns = [
  {
    header: i18n.t('basicData.ExpenseType'), // 费用类型
    key: 'feeTypeCode',
    width: 30
  },
  {
    header: i18n.t('receivablePayable.weightStart'), // 重量开始(KG) 不包含
    key: 'startWeight',
    width: 30
  },
  {
    header: i18n.t('receivablePayable.weightEndInclusive'), // 重量结束(KG) 包含
    key: 'endWeight',
    width: 30
  },
  {
    header: i18n.t('receivablePayable.priceRange'), // 区间价
    key: 'price',
    width: 30
  },
  {
    header: 'ID', // id 下载报价的时候存在
    key: 'id',
    width: 20
  }
];

// 邮局特殊规则
const postalSpecialColumns = [
  {
    header: i18n.t('basicData.ExpenseType'), // 费用类型
    key: 'feeTypeCode',
    width: 30
  },
  {
    header: i18n.t('receivablePayable.specialRules') + '-' + i18n.t('GlobalSetObj.weight') + '>', // 重量（KG）>
    key: 'overWeight',
    width: 30
  },
  {
    header: i18n.t('receivablePayable.specialRules') + '-' + i18n.t('receivablePayable.lengthWidthHeightCm') + '>', // 长/宽/高 >
    key: 'overSize',
    width: 30
  },
  {
    header: i18n.t('basicData.Price'), // 价格
    key: 'price',
    width: 30
  },
  {
    header: 'ID', // id 下载报价的时候存在
    key: 'id',
    width: 20
  }
];

// 其他规则
const otherColumns = [
  {
    header: i18n.t('basicData.ExpenseType'), // 费用类型
    key: 'feeTypeCode',
    width: 30
  },
  {
    header: i18n.t('basicData.BillingRules'), // 开始值
    key: 'startNumber',
    width: 30
  },
  {
    header: i18n.t('basicData.BillingRules'), // 结束值
    key: 'endNumber',
    width: 30
  },
  {
    header: i18n.t('basicData.BillingRules'), // 计费规则
    key: 'deliveryFeeRatio',
    width: 30
  },
  {
    header: 'ID', // id 下载报价的时候存在
    key: 'id',
    width: 20
  }
];

/**
 * 获取表头
 * @param businessType 业务类型
 * @param cargoType 货物类型
 * @param collectType 揽收方式
 */
const getHeaderObj = (businessType, cargoType, collectType) => {
  let columns;
  if (businessType === 1) { // 安骏
    columns = [...headerObj, ...hutColumns];
  } else if (businessType === 2) {
    if (collectType === 1) { // 上门交件
      columns = [...headerObj, ...deliveryColumns];
    } else if (collectType === 2) { // 上门揽收
      columns = [...headerObj, ...collectionColumns];
    }
  } else if (businessType === 3) { // AJD-大件
    if (cargoType === 1) {
      columns = [...headerObj, ...dspColumns];
    } else {
      columns = [...headerObj, ...normalColumns];
    }
  } else if (businessType === 4) { // DSP
    columns = [...headerObj, ...dspColumns];
  } else if (businessType === 5) { // 运输
    columns = [...headerObj, ...distanceColumns];
  } else if (businessType === 6) { // 邮局
    columns = [...headerObj, ...postalColumns];
  } else {
    // 兜底逻辑，防止返回 undefined
    columns = [...headerObj];
  }
  return columns;
};

/**
 * 生成模板
 * @param form 报价详情
 * @param data 价格详情
 * @param otherData 其他规则
 * @param expenseTypeList 费用类型
 * @param specialFeeList 特殊费用
 */
const createTemplate = (form, data, otherData, expenseTypeList, specialFeeList) => {
  const wb = new ExcelJs.Workbook();
  const setHeaderStyle = (worksheet) => {
    worksheet.getRow(1).font = {
      color: { argb: '000000' },
      bold: true
    };
  };
  const Sheet1 = wb.addWorksheet('基础报价');
  const Sheet2 = wb.addWorksheet('其他报价');
  const Sheet3 = wb.addWorksheet('特殊报价');
  setHeaderStyle(Sheet1);
  setHeaderStyle(Sheet2);
  setHeaderStyle(Sheet3);
  // 报价参数
  const { name, payableEntityName, siteName, partitionName, businessType, collectType, cargoType } = form;

  // 添加数据
  const buildSafeMap = (list) =>
    Array.isArray(list)
      ? new Map(list.map((item) => [item.code, item.name]))
      : new Map();
  const expenseTypeMap = buildSafeMap(expenseTypeList);
  const specialFeeMap = buildSafeMap(specialFeeList);

  const getYesNoLabel = (value) =>
    value === 1 ? i18n.t('GlobalSetObj.yes') : i18n.t('GlobalSetObj.No');

  const transformItem = (item, feeMap) => ({
    ...item,
    feeTypeCode: feeMap.get(item.feeTypeCode) || '',
    collectType:
      (COLLECT_TYPE[collectType] && COLLECT_TYPE[collectType].label) || '',
    cargoType:
      (CARGO_TYPE[cargoType] && CARGO_TYPE[cargoType].label) || '',
    vehicleType: item.vehicleName, // 车型
    partitionAffiliateId: businessType === 5 ? item.lineName : item.partitionIdentifier, // 分区/车线
    irrfSelected: getYesNoLabel(item.irrfSelected) || '',
    sestSenatSelected: getYesNoLabel(item.sestSenatSelected) || '',
    inssSelected: getYesNoLabel(item.inssSelected) || '',
    quotationMode: QUOTATION_MODEL[item.quotationMode]?.label,
    // isMix: ISMIX_START[item.isMix]?.label,
    name,
    payableEntityName,
    siteName,
    partitionName
  });

  Sheet1.columns = getHeaderObj(businessType, cargoType, collectType);
  console.log(getHeaderObj(businessType, cargoType, collectType), '----------------------------基础报价cloumns');
  const sheet1Data =
    Array.isArray(data) &&
    data
      .filter(
        (item) =>
          !item.overSize && !item.overWeight
      )
      .map((item) => transformItem(item, expenseTypeMap));
  console.log(sheet1Data, '----------------------------基础报价');
  Sheet1.addRows(sheet1Data);

  Sheet2.columns = [...headerObj, ...otherColumns];
  const sheet2Data =
    Array.isArray(otherData) &&
    otherData.map((item) => transformItem(item, specialFeeMap));
  console.log(sheet2Data, '----------------------------其他报价');
  Sheet2.addRows(sheet2Data);

  Sheet3.columns = [...headerObj, ...postalSpecialColumns];
  const sheet3Data =
    Array.isArray(data) &&
    data
      .filter(
        (item) =>
          (item.overSize !== undefined && item.overSize !== null) ||
          (item.overWeight !== undefined && item.overWeight !== null)
      )
      .map((item) => transformItem(item, expenseTypeMap));
  console.log(sheet3Data, '----------------------------特殊报价');
  Sheet3.addRows(sheet3Data);

  return wb;
};

/**
 * 下载文件
 * @param form 报价详情
 * @param data 价格详情
 * @param otherData 其他规则
 * @param expenseTypeList 费用类型
 * @param specialFeeList 特殊费用
 */
export const downloadFile = async(form, data, otherData, expenseTypeList, specialFeeList) => {
  const wb = createTemplate(form, data, otherData, expenseTypeList, specialFeeList);
  console.log(wb);
  const { name } = form;
  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/octet-stream'
  });

  saveAs(blob, `${name}-${i18n.t('basicData.QuoteDetails')}.xlsx`);
};
